import type { SubscriptionDetails } from "./definitions";

/*
 * Utility function for generating a subscription path from subscription details
 * Extracted so that they are consistent between server and client
 */
export const createSubscriptionPath = (details: SubscriptionDetails) => {
	return (details.id ? `/${details.collection}/${details.id}` : `/${details.collection}`);
}